document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook("beforeAutocompleteOptions", function (options) {
    const { searchClient } = window.algoliaShopify;
    const { getAlgoliaResults } = window.algoliaShopify.externals;
    const algoliaPrefix = window.algoliaShopify.config.index_prefix;
    const algoliaQuerySuggestionsIndex = `${algoliaPrefix}products_query_suggestions`;

    let shouldPanelOpen = true;
    const RECENTLY_SEARCHED_QUERIES_MAX_LENGTH = 3;
    const RECENTLY_VIEWED_COOKIE_NAME = getCookieNameWithEnv(window.location.hostname, "viewed-products");

    const getRecentlyViewedProducts = async () => {
      const fpCookieRecentlyViewed =
        document?.cookie?.split(RECENTLY_VIEWED_COOKIE_NAME + "=")?.[1]?.split(";")?.[0] || "%5B%5D";
      const productHandles = JSON.parse(decodeURIComponent(fpCookieRecentlyViewed));
      const productsData = productHandles.flatMap(async (productHandle) => {
        const productData = await fetch(`/products/${productHandle}.js`)
          .then((response) => response.json())
          .then((data) => data)
          .catch((error) => {
            console.error("Error fetching product data:", error);
            return null;
          });
        return productData ? [productData] : [];
      });

      try {
        return productsData.map((productData, index) => {
          return {
            __autocomplete_id: index,
            slug: productData.url,
            id: productData.id,
            image: productData.images[0],
            alt: productData.title,
          };
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        return [];
      }
    };

    const getRecentlySearched = () => {
      const fpCookieRecentlySearched =
        document?.cookie?.split("fp-searched-queries=")?.[1]?.split(";")?.[0] || "%5B%5D";
      const searchedQueries = JSON.parse(decodeURIComponent(fpCookieRecentlySearched));
      return searchedQueries;
    };

    const getRecentlySearchedArrofObjects = () => {
      const searchedQueries = getRecentlySearched();
      return searchedQueries.map((query) => ({
        searchValue: query,
      }));
    };

    const scrubbedRecentlySearched = (query, queriesList) => {
      const recentQueriesArrayIsFull = queriesList.length >= RECENTLY_SEARCHED_QUERIES_MAX_LENGTH;
      const newRecentQueries = recentQueriesArrayIsFull ? queriesList.slice(0, -1) : queriesList;

      return newRecentQueries?.filter((item) => item !== query) || [];
    };

    const addRecentlySearched = (newQuery, oldQueries) => {
      const cleanRecentlySearchedQueries = scrubbedRecentlySearched(newQuery, oldQueries);
      setCookie("fp-searched-queries", JSON.stringify([newQuery, ...cleanRecentlySearchedQueries]), 365);
    };

    const handleSubmit = (event) => {
      const searchVal = event.target[0].value.trim();
      if (searchVal) {
        event.target.reset();
        const encodedSearch = encodeURIComponent(searchVal);
        addRecentlySearched(encodedSearch, getRecentlySearched());
        window.location.assign(`https://${window.location.host}/search?q=${encodedSearch}`);
      } else {
        const detailsContainer = document.querySelector("details-modal.header__search details");
        detailsContainer.removeAttribute("open");

        document.body.removeEventListener("click", this.onBodyClickEvent);
        document.body.classList.remove("overflow-hidden");

        /* Ensures closing of Algolia's autocomplete layout on modal close */
        const aaPanel = document.querySelector(".aa-Panel");
        if (aaPanel) aaPanel.remove();
      }
    };

    const clearRecentlySearched = () => {
      setCookie("fp-searched-queries", JSON.stringify([]), 365);
      const recentlySearchedElement = document.getElementById("fp-recently-searched-plugin");
      if (recentlySearchedElement) {
        recentlySearchedElement.classList.add("hidden");
      }
    };

    const deleteRecentlySearchedQuery = (event) => {
      event.stopPropagation();
      const valueToDelete = event.target.dataset.query;
      const row = document.getElementById(valueToDelete);
      row.parentElement.remove();
      const oldQueries = getRecentlySearched();
      const newQueries = oldQueries.filter((item) => item !== valueToDelete.replaceAll("-", " "));
      const recentlySearchedElement = document.getElementById("fp-recently-searched-plugin");
      if (newQueries.length === 0) {
        if (recentlySearchedElement) {
          recentlySearchedElement.classList.add("hidden");
        }
      }
      setCookie("fp-searched-queries", JSON.stringify(newQueries), 365);
    };

    const clearRecentlyViewed = () => {
      setCookie(RECENTLY_VIEWED_COOKIE_NAME, JSON.stringify([]), 365);
      const recentlyViewedElement = document.getElementById("fp-recently-viewed-plugin");
      if (recentlyViewedElement) {
        recentlyViewedElement.classList.add("hidden");
      }
    };

    const debouncePromise = (fn, time) => {
      let timerId;

      return (...args) => {
        if (timerId) {
          clearTimeout(timerId);
        }

        return new Promise((resolve) => {
          timerId = setTimeout(() => resolve(fn(...args)), time);
        });
      };
    };

    const DEBOUNCE_TIMEOUT = 400;
    const debounced = debouncePromise((items) => Promise.resolve(items), DEBOUNCE_TIMEOUT);

    const newOptions = {
      ...options,
      placeholder: "Search for...",
      openOnFocus: true,
      detachedMediaQuery: "none",
      shouldPanelOpen() {
        return shouldPanelOpen;
      },
      onReset(params) {
        const { setIsOpen, setQuery } = params;
        setIsOpen(false);
        setQuery("");
        shouldPanelOpen = false;
      },
      onSubmit(params) {
        const { event, state } = params;
        const eventInjectQuery = event;
        eventInjectQuery.target[0].value = state.query;
        handleSubmit(eventInjectQuery);
      },
      getSources() {
        return debounced([
          {
            sourceId: "autocompletePlugin",
            getItems({ query }) {
              return query
                ? getAlgoliaResults({
                    searchClient,
                    queries: [
                      {
                        indexName: algoliaQuerySuggestionsIndex,
                        query,
                      },
                    ],
                  })
                : [];
            },
            templates: {
              item({ item, components, html }) {
                const { __autocomplete_id, query: suggestedQuery } = item;
                return html`
                  <div class="fp-autocomplete-result__row">
                    <a
                      href="/search?q=${suggestedQuery}"
                      class="fp-autocomplete-result__link"
                      role="button"
                      id="${__autocomplete_id}"
                      onclick="${() => addRecentlySearched(suggestedQuery, getRecentlySearched())}"
                    >
                      <span class="fp-autocomplete-result__matching-hit">
                        ${components.ReverseHighlight({
                          hit: item,
                          attribute: "query",
                        })}
                      </span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <rect width="14" height="14" fill="url(#pattern0_2864_2983)" />
                        <defs>
                          <pattern id="pattern0_2864_2983" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_2864_2983" transform="scale(0.00195312)" />
                          </pattern>
                          <image
                            id="image0_2864_2983"
                            width="512"
                            height="512"
                            preserveAspectRatio="none"
                            xlink:href="data:image/png;base64,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"
                          />
                        </defs>
                      </svg>
                    </a>
                  </div>
                `;
              },
            },
          },
          {
            sourceId: "recentlySearchedPlugin",
            getItems() {
              return getRecentlySearchedArrofObjects();
            },
            onSelect(params) {
              params.setIsOpen(true);
            },
            templates: {
              header({ html }) {
                return html`
                  <div class="fp-autocomplete__header">
                    <h4 class="fp-font-weight--medium">Recently Searched</h4>
                    <span
                      class="link body-sm"
                      id="fp-clear-recently-searched"
                      onclick="${clearRecentlySearched}"
                      role="button"
                    >
                      Clear
                    </span>
                  </div>
                `;
              },
              item({ item, html }) {
                const { searchValue } = item;
                const itemId = searchValue?.replaceAll(" ", "-");
                const decodedSearch = decodeURIComponent(searchValue);
                return html`
                  <div class="fp-search-result__row" id="${itemId}">
                    <a
                      title="Search for ${decodedSearch}"
                      href="/search?q=${searchValue}"
                      class="fp-search-result__link"
                    >
                      <span class="fp-recently-searched-query">${decodedSearch}</span>
                    </a>
                    <button
                      aria-label="Delete recently searched query"
                      class="fp-delete-recently-searched-query__button"
                      data-query="${itemId}"
                      onclick="${deleteRecentlySearchedQuery}"
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        data-query="${itemId}"
                        onclick="${deleteRecentlySearchedQuery}"
                      >
                        <path
                          onclick="${deleteRecentlySearchedQuery}"
                          data-query="${itemId}"
                          d="M1.23366 13C1.17385 13 1.11405 12.9771 1.0685 12.9316C0.977166 12.8402 0.977166 12.6926 1.0685 12.6012L12.6012 1.0685C12.6925 0.977166 12.8402 0.977166 12.9315 1.0685C13.0228 1.15984 13.0228 1.30747 12.9315 1.39881L1.39881 12.9316C1.35302 12.9771 1.29346 13 1.23366 13Z"
                          fill="#191C1F"
                          stroke="#191C1F"
                          stroke-width="0.5"
                        />
                        <path
                          d="M12.7663 13C12.7065 13 12.6467 12.9771 12.6012 12.9316L1.0685 1.39881C0.977166 1.30747 0.977166 1.15984 1.0685 1.0685C1.15984 0.977166 1.30747 0.977166 1.39881 1.0685L12.9315 12.6012C13.0228 12.6926 13.0228 12.8402 12.9315 12.9316C12.8857 12.9771 12.8261 13 12.7663 13Z"
                          fill="#191C1F"
                          stroke="#191C1F"
                          stroke-width="0.5"
                        />
                      </svg>
                    </button>
                  </div>
                `;
              },
            },
          },
          {
            sourceId: "recentlyViewedPlugin",
            getItems() {
              return getRecentlyViewedProducts();
            },
            templates: {
              header({ html }) {
                return html` <div class="fp-autocomplete__header">
                  <h4 class="fp-font-weight--medium">Recently Viewed</h4>
                  <span
                    class="link body-sm"
                    id="fp-clear-recently-viewed"
                    onclick="${clearRecentlyViewed}"
                    role="button"
                  >
                    Clear
                  </span>
                </div>`;
              },
              item({ item, components, html }) {
                const { __autocomplete_id, slug, id, image } = item;
                return html`
                  <div class="fp-recently-viewed-product__card" key="recentProductSearchBox-${__autocomplete_id}">
                    <a
                      title="View ${item.slug.replace("-", " ")}"
                      href="https://${window.location.host}${slug}"
                      key="recentProductSearchBox-${__autocomplete_id}"
                    >
                      <img
                        alt="Image of ${item.slug.replace("-", " ")}"
                        class="fp-recently-viewed-product__image"
                        src="${image}"
                      />
                    </a>
                    <span class="fp-underline" />
                  </div>
                `;
              },
            },
          },
          {
            sourceId: "popularSearchesPlugin",
            getItems() {
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    indexName: algoliaQuerySuggestionsIndex,
                    query: "Popular Searches",
                    params: {
                      hitsPerPage: 3,
                    },
                  },
                ],
              });
            },
            templates: {
              header({ html }) {
                return html`
                  <div class="fp-autocomplete__header">
                    <h4 class="fp-font-weight--medium">Popular Searches</h4>
                  </div>
                `;
              },
              item({ item, html }) {
                const hit = item;
                return html`
                  <div class="fp-search-result__row">
                    <a
                      href="/search?q=${String(hit.query)}"
                      class="fp-search-result__link"
                      role="button"
                      onclick="${() => addRecentlySearched(String(hit.query), getRecentlySearched())}"
                    >
                      <span class="fp-trending-search body-lg fp-font-weight--regular">
                        ${String(hit.query)}
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <rect width="14" height="14" fill="url(#pattern0_2864_2983)" />
                          <defs>
                            <pattern
                              id="pattern0_2864_2983"
                              patternContentUnits="objectBoundingBox"
                              width="1"
                              height="1"
                            >
                              <use xlink:href="#image0_2864_2983" transform="scale(0.00195312)" />
                            </pattern>
                            <image
                              id="image0_2864_2983"
                              width="512"
                              height="512"
                              preserveAspectRatio="none"
                              xlink:href="data:image/png;base64,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"
                            />
                          </defs>
                        </svg>
                      </span>
                    </a>
                  </div>
                `;
              },
            },
          },
          {
            sourceId: "helpfulLinksPlugin",
            getItems() {
              return [
                {
                  text: "Track My Order",
                  link: "/account",
                },
                {
                  text: "Purchase History",
                  link: "/account/orders",
                },
                {
                  text: "FASHIONPHILE Refresh",
                  link: "/pages/refresh",
                },
              ];
            },
            templates: {
              header({ html }) {
                return html`
                  <div class="fp-autocomplete__header">
                    <h4 class="fp-font-weight--medium">Helpful Links</h4>
                  </div>
                `;
              },
              item({ item, html }) {
                const { text, link } = item;
                return html`
                  <div class="fp-search-result__row">
                    <a title="Search for ${text}" href="${link}" class="fp-search-result__link" role="button">
                      <span class="fp-helpful-link body-lg fp-font-weight--regular"> ${text} </span>
                    </a>
                  </div>
                `;
              },
            },
          },
        ]);
      },
      render(core, root) {
        const { elements, state, render, html } = core;
        const {
          autocompletePlugin,
          recentlyViewedPlugin,
          recentlySearchedPlugin,
          popularSearchesPlugin,
          helpfulLinksPlugin,
        } = elements;

        const recentlySearchedUnorderedList = recentlySearchedPlugin?.props?.children?.[1].props;
        if (recentlySearchedUnorderedList) {
          // modify attributes of ul, li to fix accessibility issues: Interactive controls must not be nested, etc
          recentlySearchedUnorderedList.role = "list";
          recentlySearchedUnorderedList.children.map((item) => {
            item.props.role = undefined;
            item.props["aria-selected"] = undefined;
            return item;
          });
        }

        const recentlyViewedUnorderedList = recentlyViewedPlugin?.props?.children?.[1].props;
        if (recentlyViewedUnorderedList) {
          recentlyViewedUnorderedList.role = "list";
          recentlyViewedUnorderedList.children.map((item) => {
            item.props.role = undefined;
            item.props["aria-selected"] = undefined;
            return item;
          });
        }

        const detailsModal = document.querySelector("details-modal.header__search details");
        if (!detailsModal.getAttribute("open")) {
          const aaPanel = document.querySelector(".aa-Panel");
          if (aaPanel) aaPanel.style.display = "none";
        }

        if (detailsModal.getAttribute("open")) {
          const aaPanel = document.querySelector(".aa-Panel");
          if (aaPanel) aaPanel.style.display = "block";
        }

        render(
          html`
            <div class="aa-PanelLayout" id="fp-algolia-results-overlay">
              <div>
                ${autocompletePlugin
                  ? html`<div class="fp-autocomplete-results__container">${autocompletePlugin}</div>`
                  : recentlyViewedPlugin && recentlySearchedPlugin && !state.query
                    ? html`<div id="fp-recently-searched-plugin" class="fp-recently-searched__container">
                          ${recentlySearchedPlugin}
                        </div>
                        <hr class="fp-divider" />
                        <div id="fp-recently-viewed-plugin" class="fp-recently-viewed__container">
                          ${recentlyViewedPlugin}
                        </div>`
                    : recentlySearchedPlugin && !state.query
                      ? html`
                          <div id="fp-recently-searched-plugin" class="fp-recently-searched__container">
                            ${recentlySearchedPlugin}
                          </div>
                        `
                      : recentlyViewedPlugin && !state.query
                        ? html`<div id="fp-recently-viewed-plugin" class="fp-recently-viewed__container">
                            ${recentlyViewedPlugin}
                          </div>`
                        : null}
                <div
                  id="fp-popular-searches-plugin"
                  class="${(!autocompletePlugin && !recentlySearchedPlugin && !recentlyViewedPlugin) ||
                  (!autocompletePlugin && state.query)
                    ? ""
                    : "hidden"}"
                >
                  <div class="fp-popular-searches__container">${popularSearchesPlugin}</div>
                  <hr class="fp-divider" />
                  <div class="fp-helpful-links__container">${helpfulLinksPlugin}</div>
                </div>
              </div>
            </div>
          `,
          root,
        );
      },
      renderNoResults({ state, render, html }, root) {
        render(null, root);
      },
    };

    const cancelSearchButton = document.querySelector(".search-modal__close-button");
    cancelSearchButton?.addEventListener("click", () => {
      document.querySelector(".aa-ClearButton")?.click();
      shouldPanelOpen = true;
    });

    return newOptions;
  });
});

function handlePredictiveSearch(container) {
  // set aria-controls the same value as aria-owns attribute to enhance accessiblity
  container?.setAttribute(
    "aria-controls",
    "autocomplete-0-redirectUrlPlugin-list autocomplete-0-products-list autocomplete-0-collections-list autocomplete-0-querySuggestionsPlugin-list autocomplete-0-autocompletePlugin-list autocomplete-0-recentlySearchedPlugin-list autocomplete-0-recentlyViewedPlugin-list autocomplete-0-popularSearchesPlugin-list autocomplete-0-helpfulLinksPlugin-list",
  );
}

waitForElement(".aa-Autocomplete", handlePredictiveSearch);
